import React, { useEffect, useState } from 'react';
import API_URL from '../api/APIUrl';
import { useStudentAuthContext } from './useStudentAuthContext';
import { Circles } from 'react-loader-spinner'

const StudentApplication = () => {

  const {studentuser} = useStudentAuthContext();
  //const {readError, isPending, data} = useFetch(API_URL.GET_SINGLE_STUDENT_BY_EMAIL + "/" + studentuser.email);

  const [firstname, setFirstname] = useState('');
  const [middlename, setMiddlename] = useState('');
  const [surname, setSurname] = useState('');
  const [gender, setGender] = useState('');
  const [dob, setDob] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [current_address, setCurrentAddress] = useState('');
  const [permanent_address, setPermanentAddress] = useState('');
  const [last_3_years_academic_performance, set3YearsAcademicPerformance] = useState('');
  const [education_category,setEducationCategory] = useState('');
  const [need_financial_help_for, setNeedFinancialHelpFor] = useState('');
  const [institution_name, setInstitutionName] = useState('');
  const [religion, setReligion] = useState('');
  const [caste, setCaste] = useState('');
  const [sub_caste, setSubCaste] = useState('');
  const [student_whatsapp, setStudentWhatsapp] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [father_whatsapp, setFatherWhatsapp] = useState('');
  const [mother_whatsapp, setMotherWhatsapp] = useState('');
  const [total_fees, setTotalFees] = useState('');
  const [arranged_amount, setArrangedAmount] = useState('');
  const [payment_deadline, setPaymentDeadline] = useState('');
  const [emptyFields, setEmptyFields] = useState([]);
  const [error,setError] = useState(null);
  const [msg,setMsg] = useState(null);

  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);


  const [isSaved, setIsSaved] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state

  const [allReligions,setAllReligions] = useState([]);
  const [allReligionsError,setAllReligionsError] = useState(null);


  const [allCastes,setAllCastes] = useState([]);
  const [allCastesError,setAllCastesError] = useState(null);

  const [allSubCastes,setAllSubCastes] = useState([]);
  const [allSubCastesError,setAllSubCastesError] = useState(null);


  const [allStates,setAllStates] = useState([]);
  const [allStatesError,setAllStatesError] = useState(null);

  const [allCities,setAllCities] = useState([]);
  const [allCitiesError,setAllCitiesError] = useState(null);

  var json;

  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPhoto(file);
      setPhotoPreview(URL.createObjectURL(file)); // Create a preview URL
    }
  };


  // This useEffect will run each time `isSaved` is updated
  useEffect(() => {
    if (isSaved) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setIsSaved(false); // Reset the save status after scrolling
    }
  }, [isSaved]);

  const religionChange = (event) =>{ 
    setAllCastes('');
    setAllSubCastes('');
    setCaste('');
    setSubCaste('');
    setReligion(event.target.value);
   
    //console.log();
}

const casteChange = (event) =>{ 
  setAllSubCastes('')
  setSubCaste('');
  setCaste(event.target.value);
 
  //console.log();
}

const stateChange = (event) =>{ 
  setAllCities('')
  setState(event.target.value);
  //console.log();
}



useEffect(()=>{
  const fetchAllCities = async () => {
      const response = await fetch(API_URL.GET_ALL_CITIES  + state);
      const json = await response.json();
      //console.log("City: " + json);
      if(response.ok){
        setAllCities(json);
      }
      else
      { 
          setAllCities("");
      }
  }
  if(state){
    fetchAllCities();
  }
  
},[state]);


useEffect(()=>{
  const fetchAllStates = async () => {
      const response = await fetch(API_URL.GET_ALL_STATES);
      const json = await response.json();
      console.log(json);
      if(response.ok){
        setAllStates(json);
      }
      else{
        setAllStates(null);
        setAllStatesError('No states data found!');
      }
  }

  fetchAllStates();
},[]);

useEffect(()=>{
  const fetchAllCastes = async () => {
      const response = await fetch(API_URL.GET_CASTE_BY_RELIGION  + religion);
      const json = await response.json();
      console.log("Caste: " + json.title);
      if(response.ok){
        setAllCastes(json);
      }
      else
      { 
        setAllCastes("");
      }
  }
  if(religion){
    fetchAllCastes();
  }
  
},[religion]);


useEffect(()=>{
const fetchAllReligions = async () => {
    const response = await fetch(API_URL.GET_ALL_RELIGION);
    const json = await response.json();
    console.log(json);
    if(response.ok){
      setAllReligions(json);
    }
    else{
      setAllReligions(null);
      setAllReligionsError('No religion data found!');
    }
}

fetchAllReligions();
},[]);

useEffect(()=>{
  const fetchAllSubCastes = async () => {
      const response = await fetch(API_URL.GET_SUBCASTE_BY_CASTE  + caste);
      const json = await response.json();
      //console.log("Caste: " + json);
      if(response.ok){
        setAllSubCastes(json);
      }
      else
      { 
          setAllSubCastes("");
      }
  }
  if(caste){
    fetchAllSubCastes();
  }
  
},[caste]); 

  useEffect(() =>{
    const fetchStudentData = async () =>{


        try {
            const response = await fetch(API_URL.GET_SINGLE_STUDENT_BY_EMAIL + "/" + studentuser.email,{
                method: 'GET', 
                headers:{
                    'Content-Type' : 'application/json',
                    'Authorization': `Bearer ${studentuser.token}` 
                },
            });
            json = await response.json();
            if(!response.ok){
                setMsg('');
                setError(json.error);        
            }

            if(response.ok){

                //console.log("DOB: " + new Date(json.dob).toDateString());

                setFirstname(json.firstname);
                setMiddlename(json.middlename);
                setSurname(json.surname);
                setGender(json.gender);
                setDob(json.dob);
                setState(json.state);
                setCity(json.city);
                setZipcode(json.zipcode);
                setCurrentAddress(json.current_address);
                setPermanentAddress(json.permanent_address);
                set3YearsAcademicPerformance(json.last_3_years_academic_performance);
                setEducationCategory(json.education_category);
                setNeedFinancialHelpFor(json.need_financial_help_for);
                setInstitutionName(json.institution_name);
                setReligion(json.religion);
                setCaste(json.caste);
                setSubCaste(json.sub_caste);
                setStudentWhatsapp(json.student_whatsapp);
                setEmail(json.email);
                setPassword(json.password);
                setFatherWhatsapp(json.father_whatsapp);
                setMotherWhatsapp(json.mother_whatsapp);
                setTotalFees(json.total_fees);
                setArrangedAmount(json.arranged_amount);
                setPaymentDeadline(json.payment_deadline);
                setPhotoPreview(API_URL.PROFILE_PICTURE_URL + json.photo);
    
                setError(null);
                setMsg(json.message);
                setEmptyFields([]);
                console.log("Student Data Fetched By Email: ",json);
        
            }

           // console.log("FetchOutput " + json.error);
        } catch (error) {
            setError(json.error);
        }
     
    
    }
    fetchStudentData();
    
  },[json]);


  const handleSubmit = async (event) => {
      try{
        event.preventDefault();
        setLoading(true);

        //const studentData = {firstname,middlename,surname,dob,state,city,zipcode,current_address,permanent_address,last_3_years_academic_performance,need_financial_help_for,institution_name,religion,
          //  caste,sub_caste,student_whatsapp,email,password,father_whatsapp,mother_whatsapp,total_fees,arranged_amount,payment_deadline
        //};

        const formStudentData = new FormData();
        formStudentData.append('firstname',firstname);
        formStudentData.append('middlename',middlename);
        formStudentData.append('surname',surname);
        formStudentData.append('gender',gender);
        formStudentData.append('dob',dob);
        formStudentData.append('state',state);
        formStudentData.append('city',city);
        formStudentData.append('zipcode',zipcode);
        formStudentData.append('current_address',current_address);
        formStudentData.append('permanent_address',permanent_address);
        formStudentData.append('last_3_years_academic_performance',last_3_years_academic_performance);
        formStudentData.append('education_category',education_category);
        formStudentData.append('need_financial_help_for',need_financial_help_for);
        formStudentData.append('institution_name',institution_name);
        formStudentData.append('religion',religion);
        formStudentData.append('caste',caste);
        formStudentData.append('sub_caste',sub_caste);
        formStudentData.append('student_whatsapp',student_whatsapp);
        formStudentData.append('email',email);
        formStudentData.append('password',password);
        formStudentData.append('father_whatsapp',father_whatsapp);
        formStudentData.append('mother_whatsapp',mother_whatsapp);
        formStudentData.append('total_fees',total_fees);
        formStudentData.append('arranged_amount',arranged_amount);
        formStudentData.append('payment_deadline',payment_deadline);
        if(photo){
            formStudentData.append('photo', photo); // Append the file as 'photo'
        }


        const response = await fetch(API_URL.PATCH_SINGLE_STUDENT + "/" + studentuser.email,{
            method: 'PATCH', 
            headers:{
                //'Content-Type' : 'application/json',
                'Authorization': `Bearer ${studentuser.token}` 
            },
           // body: JSON.stringify(studentData),
           body: formStudentData,
           
           
        });
        const json = await response.json();
        if(!response.ok){
            setMsg('');
            setError(json.error);
            if(json.requiredFields){
                setEmptyFields(json.requiredFields);
                console.log(json.requiredFields);
            }    
            setIsSaved(true);    
            setLoading(false);       
        }
        if(response.ok){
            setError(null);
            setMsg(json.message);
            setEmptyFields([]);
            console.log("Profile Edited",json)
            setIsSaved(true);
            setLoading(false);
            //json="invoke";
    
        }
      }
      catch (error) {
        setError(error.message);
        setIsSaved(true);
        setLoading(false);
    }
  };

  return (
    <form style={styles.form}>
      <h2 style={styles.title}>Student Application</h2>
      {error && <div className="error-message">{error}</div>}
      {msg && <div className="success-message">{msg}</div>}

      <div style={styles.fieldRow}>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>First Name</label>
          <input type="text" 
          value={firstname} 
          onChange={(e) => setFirstname(e.target.value)} 
          className={`form-control ${emptyFields.includes('firstname')? 'error':''}`}
          style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Middle Name</label>
          <input type="text" value={middlename} 
          onChange={(e) => setMiddlename(e.target.value)} 
          className={`form-control ${emptyFields.includes('middlename')? 'error':''}`}
          style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Surname</label>
          <input type="text" value={surname} 
          onChange={(e) => setSurname(e.target.value)}
          className={`form-control ${emptyFields.includes('surname')? 'error':''}`}
          style={styles.input} />
        </div>

        <div style={styles.fieldContainer}>
          <label style={styles.label}>Gender</label>
     
          <select 
            className={`form-control ${emptyFields.includes('gender')? 'error':''}`} 
            onChange={(e) => setGender(e.target.value)}
            value={gender}
            style={styles.input}
            >
                <option value="">Select</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
            </select>
        </div>


        <div style={styles.fieldContainer}>
          <label style={styles.label}>Date of Birth</label>
          <input type="date" value={dob} 
          onChange={(e) => setDob(e.target.value)} 
          className={`form-control ${emptyFields.includes('dob')? 'error':''}`}
          style={styles.input} />
        </div>
      </div>

      <div style={styles.fieldRow}>
      <div style={styles.fieldContainer}>
          <label style={styles.label}>State</label>
     
          <select 
            className={`form-control ${emptyFields.includes('state')? 'error':''}`} 
            onChange={stateChange}
            value={state}
            style={styles.input}
            >
                <option value="">Select</option>
                { allStates && allStates.map((state) => (
                      <option data-pg={state._id} value={state._id}>{state.title}</option>
                    ))
                }
            </select>
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>City</label>
     
          <select 
            className={`form-control ${emptyFields.includes('city')? 'error':''}`} 
            onChange={(e) => setCity(e.target.value)} 
            value={city}
            style={styles.input}
            >
                <option value="">Select</option>
                { allCities && allCities.map((city) => (
                      <option data-pg={city._id} value={city._id}>{city.title}</option>
                    ))
                }
            </select>
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Zipcode</label>
          <input type="text" value={zipcode} 
          onChange={(e) => setZipcode(e.target.value)} 
          className={`form-control ${emptyFields.includes('zipcode')? 'error':''}`}
          style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Current Address</label>
          <input type="text" value={current_address} 
          onChange={(e) => setCurrentAddress(e.target.value)}
          className={`form-control ${emptyFields.includes('current_address')? 'error':''}`}
           style={styles.input} />
        </div>
      </div>

      <div style={styles.fieldRow}>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Permanent Address</label>
          <input type="text" value={permanent_address} 
          onChange={(e) => setPermanentAddress(e.target.value)} 
          className={`form-control ${emptyFields.includes('permanent_address')? 'error':''}`}
          style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Last 3 Years Academic Performance</label>
          <input type="text" value={last_3_years_academic_performance} 
          onChange={(e) => set3YearsAcademicPerformance(e.target.value)} 
          className={`form-control ${emptyFields.includes('last_3_years_academic_performance')? 'error':''}`}
          style={styles.input} />
        </div>

        <div style={styles.fieldContainer}>
          <label style={styles.label}>Education Category</label>
     
          <select 
            className={`form-control ${emptyFields.includes('education_category')? 'error':''}`} 
            onChange={(e) => setEducationCategory(e.target.value)}
            value={education_category}
            style={styles.input}
            >
                <option value="">Select</option>
                <option value="Pre-Primary (LKG to UKG)">Pre-Primary (LKG to UKG)</option>
                <option value="Primary (1st to 4th)">Primary (1st to 4th)</option>
                <option value="High School (5th to 10th)">High School (5th to 10th)</option>
                <option value="Junior College (11th to 12th)">Junior College (11th to 12th)</option>
                <option value="Diploma Course">Diploma Course</option>
                <option value="Graduation">Graduation</option>
                <option value="Post Graduation">Post Graduation</option>
                <option value="Professional Course">Professional Course</option>
                <option value="Administrative Course">Administrative Course</option>
                <option value="Educational Equipment ">Educational Equipment</option>
            </select>
        </div>


        <div style={styles.fieldContainer}>
          <label style={styles.label}>Need Financial Help For</label>
          <input type="text" value={need_financial_help_for} 
          onChange={(e) => setNeedFinancialHelpFor(e.target.value)} 
          className={`form-control ${emptyFields.includes('need_financial_help_for')? 'error':''}`}
          style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Institution Name</label>
          <input type="text" value={institution_name} 
          onChange={(e) => setInstitutionName(e.target.value)} 
          className={`form-control ${emptyFields.includes('institution_name')? 'error':''}`}
          style={styles.input} />
        </div>
      </div>

      <div style={styles.fieldRow}>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Religion</label>
          <select 
            className={`form-control ${emptyFields.includes('religion')? 'error':''}`} 
            onChange={religionChange}
            value={religion}
            style={styles.input}
            >
                <option value="">Select</option>
                { allReligions && allReligions.map((religion) => (
                      <option data-pg={religion.title} value={religion.title}>{religion.title}</option>
                    ))
                }
            </select>

        </div>

        <div style={styles.fieldContainer}>
          <label style={styles.label}>Caste</label>
     
          <select 
            className={`form-control ${emptyFields.includes('caste')? 'error':''}`} 
            onChange={casteChange}
            value={caste}
            style={styles.input}
            >
                <option value="">Select</option>
                { allCastes && allCastes.map((caste) => (
                      <option data-pg={caste._id} value={caste.title}>{caste.title}</option>
                    ))
                }
            </select>
        </div>

        <div style={styles.fieldContainer}>
          <label style={styles.label}>SubCaste</label>
     
          <select 
            className={`form-control ${emptyFields.includes('sub_caste')? 'error':''}`} 
            onChange={(e) => setSubCaste(e.target.value)} 
            value={sub_caste}
            style={styles.input}
            >
                <option value="">Select</option>
                { allSubCastes && allSubCastes.map((sub_caste) => (
                      <option data-pg={sub_caste._id} value={sub_caste.title}>{sub_caste.title}</option>
                    ))
                }
            </select>
        </div>

      
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Student Whatsapp</label>
          <input type="text" value={student_whatsapp} 
          onChange={(e) => setStudentWhatsapp(e.target.value)} 
          className={`form-control ${emptyFields.includes('student_whatsapp')? 'error':''}`}  
          style={styles.input} />
        </div>
      </div>

      <div style={styles.fieldRow}>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Email</label>
          <input readOnly type="email" value={email}
           onChange={(e) => setEmail(e.target.value)} 
           className={`form-control ${emptyFields.includes('email')? 'error':''}`}  
           style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Password</label>
          <input type="text" value={password}
           onChange={(e) => setPassword(e.target.value)}
           className={`form-control ${emptyFields.includes('password')? 'error':''}`}  
           style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Father Whatsapp</label>
          <input type="text" value={father_whatsapp} 
          onChange={(e) => setFatherWhatsapp(e.target.value)}
          className={`form-control ${emptyFields.includes('father_whatsapp')? 'error':''}`}  
          style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Mother Whatsapp</label>
          <input type="text" value={mother_whatsapp} 
          onChange={(e) => setMotherWhatsapp(e.target.value)} 
          className={`form-control ${emptyFields.includes('mother_whatsapp')? 'error':''}`}  
          style={styles.input} />
        </div>
      </div>

      <div style={styles.fieldRow}>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Total Fees</label>
          <input type="number" value={total_fees} 
          onChange={(e) => setTotalFees(e.target.value)} 
          className={`form-control ${emptyFields.includes('total_fees')? 'error':''}`}  
          style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Amount Already Arranged</label>
          <input type="number" value={arranged_amount} 
          onChange={(e) => setArrangedAmount(e.target.value)}
          className={`form-control ${emptyFields.includes('arranged_amount')? 'error':''}`}  
          style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Payment Deadline</label>
          <input type="date" value={payment_deadline} 
          onChange={(e) => setPaymentDeadline(e.target.value)} 
          className={`form-control ${emptyFields.includes('payment_deadline')? 'error':''}`}  
          style={styles.input} />
        </div>

        <div style={styles.fieldContainer}>
          <label style={styles.label}>Upload Photo</label>
          <input
           type="file" 
           id="photoUpload" 
           accept="image/*" 
           onChange={handlePhotoChange}   
          style={styles.input} />
        </div>

      
      {photoPreview && (
        <div style={styles.fieldContainer}>
          <p>Photo Preview:</p>
          <img 

            src={photoPreview} 
            alt="Photo Preview" 
            style={{ width: '30%', borderRadius: '8px', border: '1px solid #ccc' }} 
          />
        </div>
      )}
      </div>

      <Circles
        height="80"
        width="80"
        color="#4A90E2"
        ariaLabel="circles-loading"
        wrapperStyle={{justifyContent: "center",
        alignItems: "center",}}
        wrapperClass=""
        visible={loading}
        />              

      <button type="submit"  onClick={handleSubmit} style={styles.button} 
         onMouseEnter={(e) => Object.assign(e.target.style, styles.hover)}
         onMouseLeave={(e) => Object.assign(e.target.style, styles.button)} 
      >Save</button>
    </form>
  );
};

const styles = {
  form: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '5px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  },
  title: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  fieldRow: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: '10px',
  },
  fieldContainer: {
    flex: '1 1 calc(50% - 10px)',
    margin: '5px',
  },
  label: {
    display: 'block',
    fontWeight: 'bold',
    marginBottom: '5px',
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
  },

  button: {
    width: '100%',
    backgroundColor: '#E60240', // Accent color from the theme
    color: '#FFFFFF',
    padding: '12px 30px',
    fontSize: '1rem',
    fontWeight: '600',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
},

hover: {
    backgroundColor: '#c20035', // Darker red on hover
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
  },

};

export default StudentApplication;
